<template>
    <div></div>
</template>

<script>
var $ = require('jquery');

export default {
    name: 'Scroll',
    mounted() {
        let that = this
        $(window).scroll(function() {
			let scroll = $(window).scrollTop()

            that.buttonNavCenario(scroll)
        })
    },
    methods: {
        buttonNavCenario: function (scroll) {
            /**
             * [1] ficar na posição inicial
             * [2] acompanhar a tela
             * [3] fixar igual o outro botão
             * [4] fixar no topo
             */

            let v3 = 460
            let v4 = 208
            let condition = false
            let alturaCarousel = $("#divCarouselResult").height()

            if (alturaCarousel == 0) {
                return
            }

            // * [1] ficar na posição inicial
            condition = scroll <= 355
            this.position(condition, '#btn-nav-cenario', 'nav-cenario-posicao-1')

            // * [2] acompanhar a tela
            condition = scroll > 355 && (scroll < alturaCarousel + v3)
            this.position(condition, '#btn-nav-cenario', 'nav-cenario-posicao-2')
            
            // * [3] fixar igual o outro botão
            if (scroll > (alturaCarousel + v3) && scroll < 1845) {
                $('#btn-nav-cenario').css({ 'position': 'absolute', 'top': (alturaCarousel + v4) + 'px', 'left': 'auto', 'right': '-30px', 'z-index': '999' })
            } else {
                $('#btn-nav-cenario').css('weight', 'normal')
            }

            // * [4] fixar no topo
            condition = scroll > 1845
            this.position(condition, '#btn-nav-cenario', 'nav-cenario-posicao-4')
        },
        position: function (condition, element, classe) {
            if (condition) {
                $(element).addClass(classe);
                return
            } 

            $(element).removeClass(classe);
        },
    },
}
</script>
